<!-- Mto particular de Miscelaneas -->

<template>
  <div class="miscM" v-if="loaded">
    <dualTemplate
      :dualTipo="sync? '':'modal'"
      :modal="modal"
       persistent>

        <template v-slot:controles="{}">

          <div>

            <!-- Cabecera -->
            <div class="cabecera">
              <baseHeader
                :cfg="$cfe.headers.mto"
                :titulo='$store.state[storeName].titulo'
                @onEvent="eventHeader">
              </baseHeader>
            </div>

            <v-sheet :elevation="4">
              <div class="contenedor" style="width:1200px">

                <!-- <div v-html="info"></div> -->

                <!-- Botones Mto -->
                <div class="pt-2 d-flex justify-left" style="justify-content:space-between;width:360px">

                  <!-- Mto -->
                  <baseBtraMto class="conflex"
                    v-if="!readOnly"
                    :perm="permMto"
                    :modulo="btMtoCfg"
                    :estado="estado"
                    @onEvent="execAccion">
                  </baseBtraMto>

                  <!-- Extra -->
                  <div class="conflex" style="margin-left: 50px">
                    <baseBtraExtra class="conflex"
                      :permExtra="permExtra"
                      :modulo="btExtCfg"
                      @onEvent="execAccion">
                    </baseBtraExtra>
                  </div>

                </div>

                <!-- Controles del Mto -->
                <div class="conflex" style="padding-top:10px">
                  <div class="columna" style="width:35%">

                    <div class="conflex">
                      <v-select
                        style="flex: 1 1 80%"
                        v-bind="$select"
                        v-model="ct.tipo[2]"
                        :items="$store.state.datos_iniciales.misctipo"
                        :disabled="noEdit"
                        item-value="id"
                        item-text="name">
                      </v-select>

                      <v-checkbox
                        style="flex: 1 1 20%;padding-left:10px"
                        v-bind="$checkbox"
                        v-model="ct.baja[2]"
                        :label="ct.baja[1]"
                        :disabled="noEdit">
                      </v-checkbox>
                    </div>

                    <div class="cab" style="margin-top:5px">DATOS GENERALES</div>
                    <v-sheet v-bind="$cfg.styles.marco">
                      <uiText
                        v-model="ct.name[2]"
                        styleInput="font-weight: bold;"
                        :label="ct.name[1]"
                        :disabled="noEdit"
                        uCase>
                      </uiText>

                      <uiText
                        v-model="ct.dire[2]"
                        :label="ct.dire[1]"
                        :disabled="noEdit">
                      </uiText>

                      <ctrlF
                        :ct="ct.loc"
                        :edicion="!noEdit">
                      </ctrlF>

                      <div class="conflex">
                        <uiText
                          style="width:50%"
                          v-model="ct.cp[2]"
                          :label="ct.cp[1]"
                          :disabled="noEdit">
                        </uiText>

                        <uiText
                          style="width:50%"
                          v-model="ct.cif[2]"
                          :label="ct.cif[1]"
                          :disabled="noEdit"
                          format="cif">
                        </uiText>
                      </div>
                    </v-sheet>

                    <div class="cab">DATOS DE CONTACTO</div>
                    <v-sheet v-bind="$cfg.styles.marco">
                      <uiText
                        v-model="ct.cont1[2]"
                        :label="ct.cont1[1]"
                        :disabled="noEdit">
                      </uiText>

                      <uiText
                        v-model="ct.tlf1[2]"
                        :label="ct.tlf1[1]"
                        :disabled="noEdit">
                      </uiText>

                      <uiText
                        v-model="ct.tlf2[2]"
                        :label="ct.tlf2[1]"
                        :disabled="noEdit">
                      </uiText>

                      <div style="conflex">
                        <uiText
                          v-model="ct.movil[2]"
                          :label="ct.movil[1]"
                          :disabled="noEdit">
                        </uiText>

                        <uiText
                          v-model="ct.fax1[2]"
                          :label="ct.fax1[1]"
                          :disabled="noEdit">
                        </uiText>
                      </div>

                      <uiText
                        v-model="ct.email1[2]"
                        :label="ct.email1[1]"
                        :disabled="noEdit">
                      </uiText>

                      <uiUrl
                        v-model="ct.url[2]"
                        :label="ct.url[1]"
                        :disabled="noEdit">
                      </uiUrl>

                    </v-sheet>
                  </div>

                  <div class="columna" style="width:30%">
                    <div class="cab">ADMINISTRACIÓN</div>
                    <v-sheet v-bind="$cfg.styles.marco">
                      <!-- <div class="columna"> -->
                        <div style="conflex">
                          <v-checkbox
                            style="flex: 1 1 50%"
                            v-bind="$checkbox"
                            v-model="ct.cvarios[2]"
                            :label="ct.cvarios[1]"
                            :disabled="noEdit">
                          </v-checkbox>

                          <uiText
                            style="flex: 1 1 50%"
                            v-model="ct.razon[2]"
                            :label="ct.razon[1]"
                            :disabled="noEdit">
                          </uiText>
                        </div>

                        <uiText
                          v-model="ct.admoncont[2]"
                          :label="ct.admoncont[1]"
                          :disabled="noEdit">
                        </uiText>

                        <div style="conflex">
                          <uiText
                            style="flex: 1 1 50%"
                            v-model="ct.admontlf1[2]"
                            :label="ct.admontlf1[1]"
                            :disabled="noEdit">
                          </uiText>

                          <uiText
                            style="flex: 1 1 50%"
                            v-model="ct.admonfax1[2]"
                            :label="ct.admonfax1[1]"
                            :disabled="noEdit">
                          </uiText>
                        </div>

                        <uiText
                          v-model="ct.admonemail[2]"
                          :label="ct.admonemail[1]"
                          :disabled="noEdit">
                        </uiText>

                        <div style="conflex">
                          <uiText
                            style="flex: 0 0 33%"
                            v-model="ct.ban[2]"
                            :label="ct.ban[1]"
                            :disabled="noEdit">
                          </uiText>

                          <uiText
                            style="flex: 0 0 33%"
                            v-model="ct.cta[2]"
                            :label="ct.cta[1]"
                            :disabled="noEdit"
                            format="banco">
                          </uiText>

                          <uiText
                            style="flex: 0 0 33%"
                            v-model="ct.vto[2]"
                            :label="ct.vto[1]"
                            :disabled="noEdit">
                          </uiText>
                        </div>
                      <!-- </div> -->
                    </v-sheet>

                    <div class="cab">TIPO DE RELACIÓN</div>
                    <v-sheet v-bind="$cfg.styles.marco">
                      <v-radio-group v-model="ct.residencia[2]" row>
                        <v-radio
                          v-for="tipo in tipoResidencia"
                          :key="tipo.id"
                          :label="tipo.label"
                          :value="tipo.id"
                          :disabled="noEdit">
                        </v-radio>
                      </v-radio-group>

                      <uiText
                        v-model="ct.ccont[2]"
                        :label="ct.ccont[1]"
                        :disabled="noEdit">
                      </uiText>

                      <div class="conflex">
                        <v-checkbox
                          style="width:20%"
                          v-bind="$checkbox"
                          v-model="ct.pdi[2]"
                          :label="ct.pdi[1]"
                          :disabled="noEdit">
                        </v-checkbox>

                        <v-select
                          style="width:60%"
                          v-bind="$select"
                          v-model="ct.tRF[2]"
                          :label="ct.tRF[1]"
                          :items="itemsFiscal"
                          :disabled="noEdit"
                          item-value="id"
                          item-text="name">
                        </v-select>

                        <uiText
                          style="width:20%"
                          v-model="ct.pRF[2]"
                          :label="ct.pRF[1]"
                          :disabled="noEdit">
                        </uiText>
                      </div>


                    </v-sheet>
                  </div>

                  <div class="columna"  style="width:35%">
                    <div class="cab">COMPAÑÍA</div>
                    <v-sheet v-bind="$cfg.styles.marco">
                      <div>
                        <ctrlF
                          :ct="ct.cia_id"
                          :edicion="!noEdit">
                        </ctrlF>
                      </div>

                      <uiObs3
                        :record="record"
                        :schema="ct"
                        :schemaComponente="ct.obs"
                        :edicion="!noEdit">
                      </uiObs3>

                      <uiObs3
                        :record="record"
                        :schema="ct"
                        :schemaComponente="ct.obs2"
                        :edicion="!noEdit">
                      </uiObs3>
                    </v-sheet>

                    <div class="conflex">
                      <div class="columna" style="width:50%">
                        <div class="cab">RELACIÓN COMERCIAL</div>
                        <v-sheet v-bind="$cfg.styles.marco">
                          <v-checkbox
                            v-bind="$checkbox"
                            v-model="ct.proveedor[2]"
                            :label="ct.proveedor[1]"
                            :disabled="noEdit">
                          </v-checkbox>

                          <v-checkbox
                            style="padding-top:12px"
                            v-bind="$checkbox"
                            v-model="ct.cliente[2]"
                            :label="ct.cliente[1]"
                            :disabled="noEdit">
                          </v-checkbox>
                        </v-sheet>
                      </div>

                      <div class="columna" style="width:50%">
                        <div class="cab">TIPO DE PERSONA</div>
                        <v-sheet v-bind="$cfg.styles.marco">
                          <v-radio-group v-model="ct.persona[2]" row>
                            <v-radio
                              v-for="tipo in tipoPersona"
                              :key="tipo.id"
                              :label="tipo.label"
                              :value="tipo.id"
                              :disabled="noEdit">
                            </v-radio>
                          </v-radio-group>
                        </v-sheet>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-sheet>


            <!-- Ventana de Componentes Extra  -->
            <component
              :is="componenteDinamico"
              syncUpdate
              :storeRaiz="storeName"
              :masterStore="storeName"
              :readOnly="readOnly"
              tipoDocumento='3'
              @onEvent="$event.accion==6 || $event.accion=='salir'? componenteDinamico=null : ''">
            </component>

          </div>
        </template>
    </dualTemplate>
  </div>
</template>



<script>

  import { mixM } from "@/mixins/mixM.js";
  import baseHeader from "@/base/baseHeader";
  import baseBtraMto from "@/base/baseBtraMto";
  import baseBtraExtra from "@/base/baseBtraExtra";
  import dualTemplate from "@/components/dualTemplate";
  import ctrlF from "@/components/ctrlF";
  import commonDocsF from "@/components/commonDocsF.vue";
  import commonFrasF from "@/components/commonFrasF.vue";

  export default {
    mixins: [mixM],
    components: {
      baseHeader,
      baseBtraMto,
      baseBtraExtra,
      dualTemplate,
      ctrlF,
      commonDocsF,
      commonFrasF
    },

    props: {},

    data() {
      return {
        stIni: {
          api: "miscM",
          name:"miscM",
          titulo:"·Miscelanea",
          recordAccess:"local",
          mView:'',
          pView:[]
        },

        tipoPersona:[],
        tipoResidencia:[],
        itemsFiscal:[]
      };
    },



    methods: {
      iniDataParticular() {
        console.log("DEV " + this.stIni.api + " ********************** (iniDataParticular)");

        // añado botones extra
        this.btExtCfg.btnsAccion= [
          { "accion":'documentos', "btn": "docs" },
          { "accion":'facturas', "btn": "facturas" }
        ];


        // array de Tipo de Personas
        this.tipoPersona= [
          { id: "0", label: "FÍSICA" },
          { id: "1", label: "JURÍDICA" }
        ];

        // array de Tipo de Residencias
        this.tipoResidencia= [
          { id: "0", label: "RESIDENTE" },
          { id: "1", label: "UNIÓN EUROPEA" },
          { id: "2", label: "EXTRANJERO" }
        ];

        // array de tipos de Regimen Fiscal
        this.itemsFiscal= this.$store.state.datos_iniciales.tipo_regfiscal;
      },


      // COMPONENTES DINAMICOS (asignación)
      //
      documentos() {
        this.componenteDinamico= 'commonDocsF';
      },

      //
      facturas() {
        this.componenteDinamico= 'commonFrasF';
      }

    },

  };
</script>
